/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length)
/******/ 			resolves.shift()();
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		8: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return Promise.resolve();
/******/
/******/ 		// an Promise means "currently loading".
/******/ 		if(installedChunks[chunkId]) {
/******/ 			return installedChunks[chunkId][2];
/******/ 		}
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "chunk." + {"0":"0f35bcbcd6aae0c8f8da","1":"87669eaca40de8d3a0bf","2":"8bc7d4aaa8bbd42cd2d4","3":"d478c4f3614fbc7d6ab7","4":"d963f58361e6d9308563","5":"2039e7069859b8bb9bba","6":"ae47d12c869c189f2d71","7":"93cd341f6c0f90fc2d71"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunks[chunkId][2] = promise;
/******/
/******/ 		head.appendChild(script);
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/js/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch=='function' ? fetch : function(url, options) {
	options = options || {};
	return new Promise( function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials=='include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body);

		function response() {
			var keys = [],
				all = [],
				headers = {},
				header;

			request.getAllResponseHeaders().replace(/^(.*?):\s*([\s\S]*?)$/gm, function (m, key, value) {
				keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? (header + "," + value) : value;
			});

			return {
				ok: (request.status/200|0) == 1,		// 200-399
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function () { return Promise.resolve(request.responseText); },
				json: function () { return Promise.resolve(request.responseText).then(JSON.parse); },
				xml: function () { return Promise.resolve(request.responseXML); },
				blob: function () { return Promise.resolve(new Blob([request.response])); },
				headers: {
					keys: function () { return keys; },
					entries: function () { return all; },
					get: function (n) { return headers[n.toLowerCase()]; },
					has: function (n) { return n.toLowerCase() in headers; }
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = index;
//# sourceMappingURL=unfetch.es.js.map


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fonts__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = function () {
  var els = document.querySelectorAll('[data-clamp]');

  if (els.length) {
    Promise.all([__webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 27)), __WEBPACK_IMPORTED_MODULE_0__fonts__["a" /* default */].sofia.bold.load()]).then(function (values) {
      var shave = values[0].default;

      for (var i = 0; i < els.length; i++) {
        var lineHeight = window.getComputedStyle(els[i]).getPropertyValue('line-height');
        var maxHeight = parseFloat(lineHeight) * parseFloat(els[i].getAttribute('data-clamp')) + 2;
        shave(els[i], parseInt(maxHeight, 10));
      }
    });
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  windowWidth: function windowWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  },
  windowHeight: function windowHeight() {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  },
  wrap: function wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unfetch_polyfill__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unfetch_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_unfetch_polyfill__);



if (!window.Promise) {
  window.Promise = __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;
}

// matches polyfill
window.Element && function (ElementPrototype) {
  ElementPrototype.matches = ElementPrototype.matches || ElementPrototype.matchesSelector || ElementPrototype.webkitMatchesSelector || ElementPrototype.msMatchesSelector || function (selector) {
    var node = this;
    var nodes = (node.parentNode || node.document).querySelectorAll(selector);
    var i = -1;
    while (nodes[++i] && nodes[i] !== node) {}
    return !!nodes[i];
  };
}(window.Element.prototype);

// closest polyfill
window.Element && function (ElementPrototype) {
  ElementPrototype.closest = ElementPrototype.closest || function (selector) {
    var el = this;
    while (el.matches && !el.matches(selector)) {
      el = el.parentNode;
    }return el.matches ? el : null;
  };
}(window.Element.prototype);

// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }();
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class(el) {
    _classCallCheck(this, _class);

    this.el = el;
    this.label = el.querySelector('.js-select-label');
    this.list = el.querySelector('.js-select-list');
    this.isFilter = el.classList.contains('js-filter');
    this.field = el.querySelector('.js-select-field');

    window.addEventListener('click', this.handleClick.bind(this));
    window.addEventListener('focus', this.handleWindowFocus.bind(this), true);
  }

  _createClass(_class, [{
    key: 'handleClick',
    value: function handleClick(e) {
      if (!e.target) return;

      if (e.target.closest('.js-select') !== this.el) {
        this.close();
        return;
      }

      if (e.target.closest('.js-select-label')) {
        this.toggle();
        return;
      }

      if (e.target.closest('.js-select-option')) {
        this.label.firstElementChild.textContent = e.target.closest('.js-select-option').textContent;
        if (this.field) {
          this.field.value = e.target.closest('.js-select-option').getAttribute('data-value');
        }
        this.label.classList.remove('select__label--placeholder');
        this.label.classList.remove('filter__label--placeholder');
        this.close();
      }
    }
  }, {
    key: 'handleWindowFocus',
    value: function handleWindowFocus(e) {
      if (!e.target || e.target === window || e.target === document) return;
      if (!e.target.closest('.js-select')) this.close();
    }
  }, {
    key: 'open',
    value: function open() {
      if (this.isFilter) {
        var labelWidth = this.label.offsetWidth;
        var listWidth = this.list.offsetWidth;

        if (labelWidth < listWidth) {
          this.label.style.width = this.list.offsetWidth + 'px';
        } else {
          this.list.style.width = this.label.offsetWidth + 'px';
        }
      }

      this.el.classList.add('is-active');
    }
  }, {
    key: 'close',
    value: function close() {
      if (this.isFilter) {
        this.label.style.width = '';
      }

      this.el.classList.remove('is-active');
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.el.classList.contains('is-active')) {
        this.close();
      } else {
        this.open();
      }
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = _class;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * Cookies.js - 1.2.3
 * https://github.com/ScottHamper/Cookies
 *
 * This is free and unencumbered software released into the public domain.
 */
(function (global, undefined) {
    'use strict';

    var factory = function (window) {
        if (typeof window.document !== 'object') {
            throw new Error('Cookies.js requires a `window` with a `document` object');
        }

        var Cookies = function (key, value, options) {
            return arguments.length === 1 ?
                Cookies.get(key) : Cookies.set(key, value, options);
        };

        // Allows for setter injection in unit tests
        Cookies._document = window.document;

        // Used to ensure cookie keys do not collide with
        // built-in `Object` properties
        Cookies._cacheKeyPrefix = 'cookey.'; // Hurr hurr, :)
        
        Cookies._maxExpireDate = new Date('Fri, 31 Dec 9999 23:59:59 UTC');

        Cookies.defaults = {
            path: '/',
            secure: false
        };

        Cookies.get = function (key) {
            if (Cookies._cachedDocumentCookie !== Cookies._document.cookie) {
                Cookies._renewCache();
            }
            
            var value = Cookies._cache[Cookies._cacheKeyPrefix + key];

            return value === undefined ? undefined : decodeURIComponent(value);
        };

        Cookies.set = function (key, value, options) {
            options = Cookies._getExtendedOptions(options);
            options.expires = Cookies._getExpiresDate(value === undefined ? -1 : options.expires);

            Cookies._document.cookie = Cookies._generateCookieString(key, value, options);

            return Cookies;
        };

        Cookies.expire = function (key, options) {
            return Cookies.set(key, undefined, options);
        };

        Cookies._getExtendedOptions = function (options) {
            return {
                path: options && options.path || Cookies.defaults.path,
                domain: options && options.domain || Cookies.defaults.domain,
                expires: options && options.expires || Cookies.defaults.expires,
                secure: options && options.secure !== undefined ?  options.secure : Cookies.defaults.secure
            };
        };

        Cookies._isValidDate = function (date) {
            return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
        };

        Cookies._getExpiresDate = function (expires, now) {
            now = now || new Date();

            if (typeof expires === 'number') {
                expires = expires === Infinity ?
                    Cookies._maxExpireDate : new Date(now.getTime() + expires * 1000);
            } else if (typeof expires === 'string') {
                expires = new Date(expires);
            }

            if (expires && !Cookies._isValidDate(expires)) {
                throw new Error('`expires` parameter cannot be converted to a valid Date instance');
            }

            return expires;
        };

        Cookies._generateCookieString = function (key, value, options) {
            key = key.replace(/[^#$&+\^`|]/g, encodeURIComponent);
            key = key.replace(/\(/g, '%28').replace(/\)/g, '%29');
            value = (value + '').replace(/[^!#$&-+\--:<-\[\]-~]/g, encodeURIComponent);
            options = options || {};

            var cookieString = key + '=' + value;
            cookieString += options.path ? ';path=' + options.path : '';
            cookieString += options.domain ? ';domain=' + options.domain : '';
            cookieString += options.expires ? ';expires=' + options.expires.toUTCString() : '';
            cookieString += options.secure ? ';secure' : '';

            return cookieString;
        };

        Cookies._getCacheFromString = function (documentCookie) {
            var cookieCache = {};
            var cookiesArray = documentCookie ? documentCookie.split('; ') : [];

            for (var i = 0; i < cookiesArray.length; i++) {
                var cookieKvp = Cookies._getKeyValuePairFromCookieString(cookiesArray[i]);

                if (cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] === undefined) {
                    cookieCache[Cookies._cacheKeyPrefix + cookieKvp.key] = cookieKvp.value;
                }
            }

            return cookieCache;
        };

        Cookies._getKeyValuePairFromCookieString = function (cookieString) {
            // "=" is a valid character in a cookie value according to RFC6265, so cannot `split('=')`
            var separatorIndex = cookieString.indexOf('=');

            // IE omits the "=" when the cookie value is an empty string
            separatorIndex = separatorIndex < 0 ? cookieString.length : separatorIndex;

            var key = cookieString.substr(0, separatorIndex);
            var decodedKey;
            try {
                decodedKey = decodeURIComponent(key);
            } catch (e) {
                if (console && typeof console.error === 'function') {
                    console.error('Could not decode cookie with key "' + key + '"', e);
                }
            }
            
            return {
                key: decodedKey,
                value: cookieString.substr(separatorIndex + 1) // Defer decoding value until accessed
            };
        };

        Cookies._renewCache = function () {
            Cookies._cache = Cookies._getCacheFromString(Cookies._document.cookie);
            Cookies._cachedDocumentCookie = Cookies._document.cookie;
        };

        Cookies._areEnabled = function () {
            var testKey = 'cookies.js';
            var areEnabled = Cookies.set(testKey, 1).get(testKey) === '1';
            Cookies.expire(testKey);
            return areEnabled;
        };

        Cookies.enabled = Cookies._areEnabled();

        return Cookies;
    };
    var cookiesExport = (global && typeof global.document === 'object') ? factory(global) : factory;

    // AMD support
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return cookiesExport; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    // CommonJS/Node.js support
    } else if (typeof exports === 'object') {
        // Support Node.js specific `module.exports` (which can be a function)
        if (typeof module === 'object' && typeof module.exports === 'object') {
            exports = module.exports = cookiesExport;
        }
        // But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
        exports.Cookies = cookiesExport;
    } else {
        global.Cookies = cookiesExport;
    }
})(typeof window === 'undefined' ? this : window);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

;(function(global) {
'use strict';

var extend = __webpack_require__(25);

var hoverintent = function(el, onOver, onOut) {
  var x, y, pX, pY;
  var h = {},
    state = 0,
    timer = 0;

  var options = {
    sensitivity: 7,
    interval: 100,
    timeout: 0
  };

  function delay(el, e) {
    if (timer) timer = clearTimeout(timer);
    state = 0;
    return onOut.call(el, e);
  }

  function tracker(e) {
    x = e.clientX;
    y = e.clientY;
  }

  function compare(el, e) {
    if (timer) timer = clearTimeout(timer);
    if ((Math.abs(pX - x) + Math.abs(pY - y)) < options.sensitivity) {
      state = 1;
      return onOver.call(el, e);
    } else {
      pX = x;
      pY = y;
      timer = setTimeout(function() {
        compare(el, e);
      }, options.interval);
    }
  }

  // Public methods
  h.options = function(opt) {
    options = extend({}, options, opt);
    return h;
  };

  function dispatchOver(e) {
    if (timer) timer = clearTimeout(timer);
    el.removeEventListener('mousemove', tracker, false);

    if (state !== 1) {
      pX = e.clientX;
      pY = e.clientY;

      el.addEventListener('mousemove', tracker, false);

      timer = setTimeout(function() {
        compare(el, e);
      }, options.interval);
    }

    return this;
  }

  function dispatchOut(e) {
    if (timer) timer = clearTimeout(timer);
    el.removeEventListener('mousemove', tracker, false);

    if (state === 1) {
      timer = setTimeout(function() {
        delay(el, e);
      }, options.timeout);
    }

    return this;
  }

  h.remove = function() {
    if (!el) return;
    el.removeEventListener('mouseover', dispatchOver, false);
    el.removeEventListener('mouseout', dispatchOut, false);
  };

  if (el) {
    el.addEventListener('mouseover', dispatchOver, false);
    el.addEventListener('mouseout', dispatchOut, false);
  }

  return h;
};

global.hoverintent = hoverintent;
if (typeof module !== 'undefined' && module.exports) module.exports = hoverintent;
})(this);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var client = _ref.client;
  var key = _ref.key;
  var language = _ref.language;
  var _ref$libraries = _ref.libraries;
  var libraries = _ref$libraries === undefined ? [] : _ref$libraries;
  var _ref$timeout = _ref.timeout;
  var timeout = _ref$timeout === undefined ? 10000 : _ref$timeout;
  var v = _ref.v;

  var callbackName = '__googleMapsApiOnLoadCallback';

  return new Promise(function (resolve, reject) {

    // Exit if not running inside a browser.
    if (typeof window === 'undefined') {
      return reject(new Error('Can only load the Google Maps API in the browser'));
    }

    // Prepare the `script` tag to be inserted into the page.
    var scriptElement = document.createElement('script');
    var params = ['callback=' + callbackName];
    if (client) params.push('client=' + client);
    if (key) params.push('key=' + key);
    if (language) params.push('language=' + language);
    libraries = [].concat(libraries); // Ensure that `libraries` is an array
    if (libraries.length) params.push('libraries=' + libraries.join(','));
    if (v) params.push('v=' + v);
    scriptElement.src = 'https://maps.googleapis.com/maps/api/js?' + params.join('&');

    // Timeout if necessary.
    var timeoutId = null;
    if (timeout) {
      timeoutId = setTimeout(function () {
        window[callbackName] = function () {}; // Set the on load callback to a no-op.
        reject(new Error('Could not load the Google Maps API'));
      }, timeout);
    }

    // Hook up the on load callback.
    window[callbackName] = function () {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
      resolve(window.google.maps);
      delete window[callbackName];
    };

    // Insert the `script` tag.
    document.body.appendChild(scriptElement);
  });
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.loadjs = factory();
  }
}(this, function() {
/**
 * Global dependencies.
 * @global {Object} document - DOM
 */

var devnull = function() {},
    bundleIdCache = {},
    bundleResultCache = {},
    bundleCallbackQueue = {};


/**
 * Subscribe to bundle load event.
 * @param {string[]} bundleIds - Bundle ids
 * @param {Function} callbackFn - The callback function
 */
function subscribe(bundleIds, callbackFn) {
  // listify
  bundleIds = bundleIds.push ? bundleIds : [bundleIds];

  var depsNotFound = [],
      i = bundleIds.length,
      numWaiting = i,
      fn,
      bundleId,
      r,
      q;

  // define callback function
  fn = function (bundleId, pathsNotFound) {
    if (pathsNotFound.length) depsNotFound.push(bundleId);

    numWaiting--;
    if (!numWaiting) callbackFn(depsNotFound);
  };

  // register callback
  while (i--) {
    bundleId = bundleIds[i];

    // execute callback if in result cache
    r = bundleResultCache[bundleId];
    if (r) {
      fn(bundleId, r);
      continue;
    }

    // add to callback queue
    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
    q.push(fn);
  }
}


/**
 * Publish bundle load event.
 * @param {string} bundleId - Bundle id
 * @param {string[]} pathsNotFound - List of files not found
 */
function publish(bundleId, pathsNotFound) {
  // exit if id isn't defined
  if (!bundleId) return;

  var q = bundleCallbackQueue[bundleId];

  // cache result
  bundleResultCache[bundleId] = pathsNotFound;

  // exit if queue is empty
  if (!q) return;

  // empty callback queue
  while (q.length) {
    q[0](bundleId, pathsNotFound);
    q.splice(0, 1);
  }
}


/**
 * Load individual file.
 * @param {string} path - The file path
 * @param {Function} callbackFn - The callback function
 */
function loadFile(path, callbackFn, args, numTries) {
  var doc = document,
      async = args.async,
      maxTries = (args.numRetries || 0) + 1,
      beforeCallbackFn = args.before || devnull,
      isCss,
      e;

  numTries = numTries || 0;

  if (/\.css$/.test(path)) {
    isCss = true;

    // css
    e = doc.createElement('link');
    e.rel = 'stylesheet';
    e.href = path;
  } else {
    // javascript
    e = doc.createElement('script');
    e.src = path;
    e.async = async === undefined ? true : async;
  }

  e.onload = e.onerror = e.onbeforeload = function (ev) {
    var result = ev.type[0];

    // Note: The following code isolates IE using `hideFocus` and treats empty
    // stylesheets as failures to get around lack of onerror support
    if (isCss && 'hideFocus' in e) {
      try {
        if (!e.sheet.cssText.length) result = 'e';
      } catch (x) {
        // sheets objects created from load errors don't allow access to
        // `cssText`
        result = 'e';
      }
    }

    // handle retries in case of load failure
    if (result == 'e') {
      // increment counter
      numTries += 1;

      // exit function and try again
      if (numTries < maxTries) {
        return loadFile(path, callbackFn, args, numTries);
      }
    }

    // execute callback
    callbackFn(path, result, ev.defaultPrevented);
  };

  // execute before callback
  beforeCallbackFn(path, e);

  // add to document
  doc.head.appendChild(e);
}


/**
 * Load multiple files.
 * @param {string[]} paths - The file paths
 * @param {Function} callbackFn - The callback function
 */
function loadFiles(paths, callbackFn, args) {
  // listify paths
  paths = paths.push ? paths : [paths];

  var numWaiting = paths.length,
      x = numWaiting,
      pathsNotFound = [],
      fn,
      i;

  // define callback function
  fn = function(path, result, defaultPrevented) {
    // handle error
    if (result == 'e') pathsNotFound.push(path);

    // handle beforeload event. If defaultPrevented then that means the load
    // will be blocked (ex. Ghostery/ABP on Safari)
    if (result == 'b') {
      if (defaultPrevented) pathsNotFound.push(path);
      else return;
    }

    numWaiting--;
    if (!numWaiting) callbackFn(pathsNotFound);
  };

  // load scripts
  for (i=0; i < x; i++) loadFile(paths[i], fn, args);
}


/**
 * Initiate script load and register bundle.
 * @param {(string|string[])} paths - The file paths
 * @param {(string|Function)} [arg1] - The bundleId or success callback
 * @param {Function} [arg2] - The success or error callback
 * @param {Function} [arg3] - The error callback
 */
function loadjs(paths, arg1, arg2) {
  var bundleId,
      args;

  // bundleId (if string)
  if (arg1 && arg1.trim) bundleId = arg1;

  // args (default is {})
  args = (bundleId ? arg2 : arg1) || {};

  // throw error if bundle is already defined
  if (bundleId) {
    if (bundleId in bundleIdCache) {
      throw "LoadJS";
    } else {
      bundleIdCache[bundleId] = true;
    }
  }

  // load scripts
  loadFiles(paths, function (pathsNotFound) {
    // success and error callbacks
    if (pathsNotFound.length) (args.error || devnull)(pathsNotFound);
    else (args.success || devnull)();

    // publish bundle load event
    publish(bundleId, pathsNotFound);
  }, args);
}


/**
 * Execute callbacks when dependencies have been satisfied.
 * @param {(string|string[])} deps - List of bundle ids
 * @param {Object} args - success/error arguments
 */
loadjs.ready = function ready(deps, args) {
  // subscribe to bundle load event
  subscribe(deps, function (depsNotFound) {
    // execute callbacks
    if (depsNotFound.length) (args.error || devnull)(depsNotFound);
    else (args.success || devnull)();
  });

  return loadjs;
};


/**
 * Manually satisfy bundle dependencies.
 * @param {string} bundleId - The bundle id
 */
loadjs.done = function done(bundleId) {
  publish(bundleId, []);
};


/**
 * Reset loadjs dependencies statuses
 */
loadjs.reset = function reset() {
  bundleIdCache = {};
  bundleResultCache = {};
  bundleCallbackQueue = {};
};


/**
 * Determine if bundle has already been defined
 * @param String} bundleId - The bundle id
 */
loadjs.isDefined = function isDefined(bundleId) {
  return bundleId in bundleIdCache;
};


// export
return loadjs;

}));


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"50\" height=\"63.05\" viewBox=\"0 0 50 63.05\">\n  <circle fill=\"#fff\" cx=\"25\" cy=\"25\" r=\"25\"/>\n  <polygon fill=\"#fff\" points=\"37.49 43.67 25.08 63.05 12.67 43.67 25.08 29.52 37.49 43.67\"/>\n  <path fill=\"#f15b4f\" d=\"M29.89,16.17a7.1,7.1,0,0,1,7.1,7.1v7.49a2.32,2.32,0,0,1-4.63,0V23.27a2.46,2.46,0,1,0-4.93,0v7.49a2.32,2.32,0,0,1-4.63,0V23.27a2.46,2.46,0,1,0-4.93,0v7.49a2.32,2.32,0,0,1-4.63,0V23.27A7.1,7.1,0,0,1,25.11,18a7.06,7.06,0,0,1,4.78-1.85M25.08,3.79A21.22,21.22,0,1,0,46.3,25,21.22,21.22,0,0,0,25.08,3.79\"/>\n  <polygon fill=\"#f15b4f\" points=\"32.21 44.79 25.08 55.92 17.95 44.79 25.08 36.65 32.21 44.79\"/>\n</svg>\n"

/***/ }),
/* 12 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver_fontfaceobserver_standalone__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver_fontfaceobserver_standalone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fontfaceobserver_fontfaceobserver_standalone__);


/* harmony default export */ __webpack_exports__["a"] = {
  sofia: {
    bold: new __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver_fontfaceobserver_standalone___default.a('sofia-pro', { weight: 700 })
  }
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function r(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function t(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;left:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function y(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function z(a,b){function c(){var a=k;y(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);y(a)};function A(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var B=null,C=null,E=null,F=null;function G(){if(null===C)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);C=!!a&&603>parseInt(a[1],10)}else C=!1;return C}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
A.prototype.load=function(a,b){var c=this,k=a||"BESbswy",q=0,D=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=D?b():document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},function(){b()})}e()}),N=new Promise(function(a,c){q=setTimeout(c,D)});Promise.race([N,M]).then(function(){clearTimeout(q);a(c)},function(){b(c)})}else m(function(){function u(){var b;if(b=-1!=
f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===B&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),B=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=B&&(f==v&&g==v&&h==v||f==w&&g==w&&h==w||f==x&&g==x&&h==x)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(q),a(c))}function I(){if((new Date).getTime()-H>=D)d.parentNode&&d.parentNode.removeChild(d),b(c);else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,
g=n.a.offsetWidth,h=p.a.offsetWidth,u();q=setTimeout(I,50)}}var e=new r(k),n=new r(k),p=new r(k),f=-1,g=-1,h=-1,v=-1,w=-1,x=-1,d=document.createElement("div");d.dir="ltr";t(e,L(c,"sans-serif"));t(n,L(c,"serif"));t(p,L(c,"monospace"));d.appendChild(e.a);d.appendChild(n.a);d.appendChild(p.a);document.body.appendChild(d);v=e.a.offsetWidth;w=n.a.offsetWidth;x=p.a.offsetWidth;I();z(e,function(a){f=a;u()});t(e,L(c,'"'+c.family+'",sans-serif'));z(n,function(a){g=a;u()});t(n,L(c,'"'+c.family+'",serif'));
z(p,function(a){h=a;u()});t(p,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=A:(window.FontFaceObserver=A,window.FontFaceObserver.prototype.load=A.prototype.load);}());


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);

    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23).setImmediate))

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(12), __webpack_require__(19)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(22);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

if (!window.fetch) window.fetch = __webpack_require__(2).default || __webpack_require__(2);


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_load_google_maps_api__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_load_google_maps_api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_load_google_maps_api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mapMarker__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mapMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mapMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loadjs__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__clamp__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cookies_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_cookies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_cookies_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoverintent__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoverintent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hoverintent__);
/* global $ */















function main() {
  var highlight = document.querySelector(".js-nav-highlight");
  var initialWidth = highlight.offsetWidth;
  var navigationToggle = document.querySelector(".js-nav-toggle");

  var mobileSubNavItems = Array.from(document.querySelectorAll(".sub-nav.js-sub-nav"));

  for (var i = 0; i < mobileSubNavItems.length; i++) {
    mobileSubNavItems[i].addEventListener("click", function () {
      if (navigationToggle) {
        navigationToggle.click();
      }
    });
  }

  var closeForTodayBtns = Array.from(document.querySelectorAll(".js-closed-for-today"));

  for (var i = 0; i < closeForTodayBtns.length; i++) {
    closeForTodayBtns[i].addEventListener("click", function (e) {
      $.ajax({
        type: "POST",
        url: "/toggle-closed-today",
        data: {
          tenant_id: e.target.getAttribute("data-tenant_id"),
          day: e.target.getAttribute("data-day")
        },
        success: function success(data) {
          if (data.success == true) {
            var closedTodayLabel = document.querySelector(".day-" + e.target.getAttribute("data-day") + ".closed-today-label");
            var hoursToday = document.querySelector(".day-" + e.target.getAttribute("data-day") + ".day-hours-input");
            var twentyFourHoursLabel = document.querySelector(".day-" + e.target.getAttribute("data-day") + ".day-24-label");

            if (data.closed == 1) {
              e.target.innerHTML = "Open Today";
              closedTodayLabel.style.display = "block";
              hoursToday.style.display = "none";
              twentyFourHoursLabel.style.display = "none";
            } else {
              e.target.innerHTML = "Close Today";
              closedTodayLabel.style.display = "none";
              twentyFourHoursLabel.style.display = "none";
              hoursToday.style.display = "block";
            }
          }
        }
      });
    });
  }

  var open24HoursBtns = document.getElementsByClassName("open-24-hours-btn");

  for (var _i = 0; _i < open24HoursBtns.length; _i++) {
    if (typeof open24HoursBtns[_i] !== "undefined") {
      open24HoursBtns[_i].addEventListener("click", function (e) {
        var dayId = e.target.getAttribute("data-day");

        $.ajax({
          type: "POST",
          url: "/toggle-tenant-24-hours",
          data: {
            tenant_id: e.target.getAttribute("data-tenant-id"),
            day_id: dayId
          },
          success: function success(data) {
            var label = document.getElementsByClassName("day-" + dayId + " day-24-label")[0];
            var inputs = document.getElementsByClassName("day-" + dayId + " day-hours-input")[0];
            var closedTodayLabel = document.querySelector(".day-" + e.target.getAttribute("data-day") + ".closed-today-label");

            if (data.twentyFour) {
              label.style.display = "block";
              inputs.style.display = "none";
              closedTodayLabel.style.display = "none";
              e.target.innerHTML = "Not Open 24 Hours";
            } else {
              label.style.display = "none";
              inputs.style.display = "block";
              e.target.innerHTML = "Open 24 Hours";
            }
          }
        });
      });
    }
  }

  var allOpen24hoursBtn = document.getElementsByClassName("all-open-24-hours-btn")[0];

  if (allOpen24hoursBtn) {
    allOpen24hoursBtn.addEventListener("click", function (e) {
      $.ajax({
        type: "POST",
        url: "/toggle-tenants-all-24-hours",
        data: {
          tenant_id: e.target.getAttribute("data-tenant-id")
        },
        success: function success() {
          var dayLabels = document.getElementsByClassName("day-24-label");

          for (var i = 0; i < dayLabels.length; i++) {
            dayLabels[i].innerHTML = "Open 24 Hours";
          }
        }
      });
    });
  }

  document.querySelector(".js-nav").addEventListener("mouseover", function (e) {
    var link = e.target.closest(".js-nav-link");
    if (!link) return;

    var left = initialWidth + 2 + link.offsetLeft - 10;
    var width = link.offsetWidth + 20;

    highlight.style.transform = "translate3d(" + left + "px, 0, 0) scale(" + width / initialWidth + ", 1)";
  });

  document.querySelector(".js-nav").addEventListener("mouseleave", function (e) {
    highlight.style.transform = "none";
  });

  /**
   * Icons
   */
  __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 21)).then(function (svg) {
    var div = document.createElement("div");
    div.style.display = "none";
    div.innerHTML = svg;
    document.body.insertBefore(div, document.body.firstElementChild);
  });

  /**
   * Clamp
   */
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__clamp__["a" /* default */])();

  /**
   * Nav
   */
  var nav = document.querySelector(".js-nav");
  var navToggle = document.querySelector(".js-nav-toggle");

  if (__WEBPACK_IMPORTED_MODULE_7_cookies_js___default.a.get("menu-open") === "true" && __WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */].windowWidth() >= 1200) {
    document.body.classList.add("nav-open");
  }

  if (navToggle) {
    navToggle.addEventListener("click", function (e) {
      e.preventDefault();

      document.body.classList.toggle("nav-open");

      if (__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */].windowWidth() >= 1200) {
        __WEBPACK_IMPORTED_MODULE_7_cookies_js___default.a.set("menu-open", document.body.classList.contains("nav-open").toString());
      }
    });
  }

  nav.addEventListener("click", function (e) {
    var expand = e.target.closest(".js-nav-expand");

    if (expand) {
      var item = expand.closest(".js-nav-item");
      item.classList.toggle("is-active");
    }
  });

  /**
   * Slider
   */
  var sliderEls = Array.from(document.querySelectorAll(".js-slider"));
  sliderEls.forEach(function (sliderEl) {
    var info = sliderEl.querySelectorAll(".js-slider-info");
    var infoContainer = sliderEl.querySelector(".js-slider-info-container");
    // const content = document.querySelectorAll('.js-slider-content')
    var content = {};
    var selectedIndex = 0;

    if (info.length && info[0].getAttribute("data-index") === "1") {
      infoContainer.classList.add("is-visible");
    }

    __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 15)).then(function (Flickity) {
      for (var j = 0; j < info.length; j++) {
        if (window.site.isAdmin) {
          // !isAdmin
          content[info[j].getAttribute("data-index")] = info[j].firstElementChild;
          infoContainer.appendChild(info[j].firstElementChild);
        } else {
          var clone = info[j].firstElementChild.cloneNode(true);
          content[info[j].getAttribute("data-index")] = clone;
          infoContainer.appendChild(clone);
        }
      }

      var slider = new Flickity(sliderEl, {
        cellSelector: ".js-slider-item",
        prevNextButtons: false,
        wrapAround: true,
        adaptiveHeight: true,
        autoPlay: 5000,
        draggable: !window.site.isAdmin
      });

      slider.on("select", function () {
        var newSelectedIndex = slider.selectedIndex;
        if (newSelectedIndex === selectedIndex) return;

        if (content["" + (selectedIndex + 1)]) {
          content["" + (selectedIndex + 1)].classList.remove("is-active");
        }
        if (content["" + (newSelectedIndex + 1)]) {
          infoContainer.classList.add("is-visible");
          content["" + (newSelectedIndex + 1)].classList.add("is-active");
        } else {
          if (infoContainer) {
            infoContainer.classList.remove("is-visible");
          }
        }
        selectedIndex = newSelectedIndex;
      });

      var nextBtn = sliderEl.querySelector(".js-slider-next");
      var prevBtn = sliderEl.querySelector(".js-slider-prev");

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          slider.next();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          slider.previous();
        });
      }
    });
  });

  /**
   * Grid
   */
  var grid = document.querySelector(".js-grid");
  if (grid) {
    __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 18)).then(function (Packery) {
      // eslint-disable-next-line
      var packery = new Packery(grid, {
        itemSelector: ".js-grid-item",
        gutter: 0,
        percentPosition: true,
        transitionDuration: 0
      });

      if (window.site.isAdmin) {
        __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 14)).then(function (Draggabilly) {
          packery.getItemElements().forEach(function (itemElem) {
            var draggie = new Draggabilly(itemElem);
            packery.bindDraggabillyEvents(draggie);
          });

          // show item order after layout
          function orderItems() {
            var items = [];

            packery.getItemElements().forEach(function (itemElem, i) {
              var item = {
                id: $(itemElem).data("id"),
                position: i
              };
              items.push(item);
            });

            var json = JSON.stringify(items);

            $.ajax({
              type: "POST",
              url: "/api/1.0/sections/update",
              data: {
                data: json
              },
              success: function success(response) {},
              error: function error() {
                alert("Something went wrong with saving the positions");
              }
            });
          }

          packery.on("dragItemPositioned", orderItems);
        });
      }
    });
  }

  /**
   * Share links
   */
  {
    (function () {
      var links = document.querySelectorAll(".js-share-link");

      var _loop = function _loop(_i2) {
        links[_i2].addEventListener("click", function (e) {
          e.preventDefault();

          openWindow(links[_i2].href);
        });
      };

      for (var _i2 = 0; _i2 < links.length; _i2++) {
        _loop(_i2);
      }
    })();
  }

  function openWindow(url) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 440;

    var left = window.screen.width / 2 - width / 2;
    var top = window.screen.height / 2 - height / 2;

    window.open(url, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
  }

  /**
   * Sidebar nav mobile dropdown
   */
  var sidebarNav = document.querySelector(".js-sidebar-nav");
  var sidebarItems = void 0;

  if (sidebarNav) {
    sidebarItems = sidebarNav.querySelectorAll(".js-sidebar-nav-link");
  }

  if (sidebarNav && sidebarItems && sidebarItems.length) {
    var container = document.createElement("div");
    container.classList.add("mobile-select");
    var selectLabel = document.createElement("div");
    selectLabel.classList.add("mobile-select__label");
    container.appendChild(selectLabel);
    var select = document.createElement("select");

    var heading = document.querySelector(".js-sidebar-nav-heading");
    if (heading) {
      var headingOption = document.createElement("option");
      headingOption.setAttribute("selected", "selected");
      headingOption.setAttribute("disabled", "disabled");
      headingOption.textContent = selectLabel.textContent = heading.textContent.trim();
      select.appendChild(headingOption);
    }

    for (var _i3 = 0; _i3 < sidebarItems.length; _i3++) {
      var item = sidebarItems[_i3];
      var option = document.createElement("option");
      option.value = item.getAttribute("href");
      option.textContent = item.textContent.trim();
      select.appendChild(option);

      if (!heading && _i3 === 0) {
        selectLabel.textContent = item.textContent.trim();
      }
    }

    container.appendChild(select);

    __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1)).then(function (SmoothScroll) {
      select.addEventListener("change", function (e) {
        var target = document.querySelector(select.value);
        target.scrollIntoView({ behavior: "smooth" });
        window.history.replaceState({}, "", select.value);
        selectLabel.textContent = select.options[select.selectedIndex].textContent;
      });
    });

    sidebarNav.parentNode.insertBefore(container, sidebarNav);
  }

  /**
   * Sticky sidebar
   */
  var sidebar = document.querySelector(".js-sidebar");
  if (sidebar) {
    initStickyfill();
    window.addEventListener("resize", initStickyfill);
  }

  var stickyfillEnabled = false;

  function initStickyfill() {
    if (__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */].windowWidth() >= 1200 && !stickyfillEnabled) {
      stickyfillEnabled = true;
      __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 0)).then(function (StickyFill) {
        StickyFill.add(sidebar);
      });
    } else if (__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */].windowWidth() < 1200 && stickyfillEnabled) {
      stickyfillEnabled = false;
      __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 0)).then(function (StickyFill) {
        StickyFill.remove(sidebar);
      });
    }
  }

  /**
   * Sidebar nav scroll to
   */
  var links = document.querySelectorAll(".js-sidebar-nav-link");

  if (links.length) {
    __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 1)).then(function (SmoothScroll) {
      SmoothScroll.polyfill();

      var _loop2 = function _loop2(_i4) {
        var link = links[_i4];

        var href = link.getAttribute("href");
        var target = document.querySelector(href);

        if (target) {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
            window.history.replaceState({}, "", href);
          });
        }
      };

      for (var _i4 = 0; _i4 < links.length; _i4++) {
        _loop2(_i4);
      }
    });

    if (__WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */].windowWidth() >= 1200) {
      __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 17)).then(function (gumshoe) {
        gumshoe.init({
          selector: ".js-sidebar-nav-link",
          activeClass: "is-active",
          offset: __WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */].windowHeight() / 3
        });
      });
    }
  }

  /**
   * Sidebar extras
   */
  {
    var extras = document.querySelectorAll(".js-sidebar-extras");

    if (extras.length) {
      for (var _i5 = 0; _i5 < extras.length; _i5++) {
        sidebar.appendChild(extras[_i5].cloneNode(true));
      }

      window.requestAnimationFrame(__WEBPACK_IMPORTED_MODULE_6__clamp__["a" /* default */]);
    }
  }

  /**
   * Custom select
   */
  var selects = document.querySelectorAll(".js-select");
  if (selects.length) {
    for (var _i6 = 0; _i6 < selects.length; _i6++) {
      var _select = selects[_i6];
      new __WEBPACK_IMPORTED_MODULE_3__select__["a" /* default */](_select); // eslint-disable-line
    }
  }

  /**
   * Map
   */
  var mapCanvas = document.querySelector(".js-map");
  if (mapCanvas) {
    __WEBPACK_IMPORTED_MODULE_1_load_google_maps_api___default()({
      key: "AIzaSyBNBgyprgxCZp1Ham8u7j3Od19PcdMNltM"
    }).then(function (googleMaps) {
      var center = { lat: 53.481593, lng: -2.228194 };

      var map = new googleMaps.Map(mapCanvas, {
        zoom: 16,
        center: center,
        scrollwheel: false
      });

      // eslint-disable-next-line
      var marker = new googleMaps.Marker({
        position: center,
        map: map
      });
    });
  }

  /**
   * Typeform
   */
  var typeform = document.querySelector(".js-typeform");
  if (typeform) {
    __WEBPACK_IMPORTED_MODULE_4_loadjs___default()("https://s3-eu-west-1.amazonaws.com/share.typeform.com/widget.js");
  }

  /**
   * Floorplan
   */
  var floorplan = document.querySelector(".js-floorplan");
  if (floorplan) {
    var updateCategory = function updateCategory(category) {
      hoverEnabled = false;

      var transitionDelayed = floorplan.querySelector(".no-transition-delay");
      if (transitionDelayed) transitionDelayed.classList.remove("no-transition-delay");

      window.history.replaceState({}, "", "#" + category);

      for (var _i8 = 0; _i8 < p.length; _i8++) {
        if (p[_i8].cats.indexOf(category) !== -1 && p[_i8].visible === false) {
          p[_i8].el.classList.add("is-visible");
          p[_i8].visible = true;

          if (!p[_i8].imageLoaded) {
            p[_i8].image.src = p[_i8].image.getAttribute("data-src");
            p[_i8].imageLoaded = true;
          }
        } else if (p[_i8].cats.indexOf(category) === -1 && p[_i8].visible === true) {
          p[_i8].visible = false;
          p[_i8].el.classList.remove("is-visible");
        }
      }
    };

    var handleHoverAndClick = function handleHoverAndClick(e) {
      if (!hoverEnabled) return;
      if (e.target && e.target.id) {
        var id = e.target.id.match(/:([0-9]+)/);
        if (!id) return;
        var pin = floorplan.querySelector("[data-unit=\"" + id[1] + "\"]");
        if (!pin) return;

        if (hovered) {
          hovered.el.classList.remove("is-visible");
          hovered.el.classList.remove("no-transition-delay");
          hovered.visible = false;
        }

        var pinref = p.filter(function (a) {
          return a.el === pin;
        });
        hovered = pinref[0];
        hovered.visible = true;
        hovered.el.classList.add("is-visible");
        hovered.el.classList.add("no-transition-delay");

        if (!hovered.imageLoaded) {
          hovered.image.src = hovered.image.getAttribute("data-src");
          hovered.imageLoaded = true;
        }
      }
    };

    var pins = floorplan.querySelectorAll(".js-floorplan-pin");
    var p = [];
    var hoverEnabled = true;

    var initialSelection = null;
    var initialCategory = "popular";

    var hash = window.location.hash;
    if (hash && hash.length > 1) {
      hash = hash.substr(1);
      if (!isNaN(parseFloat(hash)) && isFinite(hash)) {
        // is numeric
        initialSelection = floorplan.querySelector("[data-unit=\"" + hash + "\"]");
      } else {
        initialCategory = hash;
      }
      hoverEnabled = false;
    }

    if (!initialSelection) {
      var radio = document.querySelector(".js-floorplan-category[value=\"" + initialCategory + "\"]");
      if (radio) radio.checked = true;
    }

    for (var _i7 = 0; _i7 < pins.length; _i7++) {
      var cats = pins[_i7].getAttribute("data-category").split(",");
      var visible = false;
      var image = pins[_i7].querySelector("img");
      var imageLoaded = false;

      if (initialSelection) {
        if (initialSelection === pins[_i7]) {
          image.src = image.getAttribute("data-src");
          imageLoaded = true;
          visible = true;
          pins[_i7].classList.add("is-visible");
        }
      } else if (cats.indexOf(initialCategory) !== -1) {
        image.src = image.getAttribute("data-src");
        imageLoaded = true;
        visible = true;
        pins[_i7].classList.add("is-visible");
      }

      p.push({
        el: pins[_i7],
        cats: cats,
        visible: visible,
        image: image,
        imageLoaded: imageLoaded
      });
    }

    var dropdown = document.querySelector(".js-floorplan-dropdown-select");
    var dropdownLabel = document.querySelector(".js-floorplan-dropdown-label");

    window.addEventListener("change", function (e) {
      if (e.target.name !== "category") return;

      updateCategory(e.target.value);

      var option = dropdown.querySelector("option[value=\"" + e.target.value + "\"]");
      if (option) {
        option.selected = true;
        dropdownLabel.textContent = option.textContent.trim();
      }
    }, true);

    /**
     * Dropdown (small screens)
     */

    if (!initialSelection && initialCategory) {
      var _option = dropdown.querySelector("option[value=\"" + initialCategory + "\"]");
      if (_option) {
        _option.selected = true;
        dropdownLabel.textContent = _option.textContent.trim();
      }
    }

    dropdown.addEventListener("change", function (e) {
      var option = dropdown.options[dropdown.selectedIndex];
      updateCategory(option.value);
      dropdownLabel.textContent = option.textContent.trim();

      document.querySelector(".js-floorplan-category[value=\"" + option.value + "\"]").checked = true;
    });

    /**
     * Hover
     */
    var hovered = null;

    var units = Array.from(floorplan.querySelectorAll('[id^="unit:"]'));
    units.forEach(function (unit) {
      __WEBPACK_IMPORTED_MODULE_8_hoverintent___default()(unit, handleHoverAndClick, function () {});
    });

    // floorplan.addEventListener('mouseover', handleHoverAndClick)
    floorplan.addEventListener("click", handleHoverAndClick);
  }

  /**
   * News load more
   */
  var offsetNews = 1;

  window.addEventListener("click", function (e) {
    var loadMoreBtn = e.target.closest(".js-load-more");
    if (!loadMoreBtn) return;

    e.preventDefault();

    var container = document.querySelector(".js-load-more-container");
    var headers = {
      "X-Requested-With": "XMLHttpRequest"
    };
    var categoryContent = document.querySelector(".category-filter-value").textContent;
    var category = categoryContent !== "Category" ? categoryContent : "all";
    var yearContent = document.querySelector(".year-filter-value").textContent;
    var year = yearContent !== "Year" ? yearContent : null;
    var monthContent = document.querySelector(".month-filter-value").textContent;
    var month = monthContent !== "Month" ? monthContent : null;
    var formData = new window.FormData();

    formData.append("_token", document.querySelector('meta[name="csrf-token"]').content);
    formData.append("category", category);
    formData.append("year", year);
    formData.append("month", month);
    formData.append("offset", offsetNews);

    loadMoreBtn.setAttribute("disabled", "disabled");
    loadMoreBtn.textContent = "Loading Articles...";

    window.fetch(window.site.url + "/news/load-more", {
      method: "post",
      body: formData,
      credentials: "include",
      headers: headers
    }).then(function (res) {
      return res.json();
    }).then(function (res) {
      offsetNews += 1;

      loadMoreBtn.setAttribute("href", window.site.url + "/news/load-more/" + offsetNews);
      loadMoreBtn.removeAttribute("disabled");
      loadMoreBtn.textContent = "More Articles";

      container.setAttribute("data-max", res.max);
      container.innerHTML += res.news;

      if (offsetNews * 9 >= res.max) {
        loadMoreBtn.parentNode.removeChild(loadMoreBtn);
      }
    });
  });

  var categoryNews = document.querySelector(".category-filter");

  if (categoryNews) {
    var year = document.querySelector(".year-filter");
    var month = document.querySelector(".month-filter");
    var _categoryNews = document.querySelector(".category-filter");
    var categoryNewsValue = document.querySelector(".category-filter-value").textContent;
    var yearValue = document.querySelector(".year-filter-value").textContent;
    var monthValue = document.querySelector(".month-filter-value").textContent;

    Array.from(_categoryNews.querySelectorAll("li button")).forEach(function (category) {
      category.addEventListener("click", function (e) {
        var href = "";

        if (category.getAttribute("data-value") === "") {
          category.setAttribute("data-value", "all");
        }

        if (Number.isInteger(parseInt(yearValue)) && Number.isInteger(parseInt(monthValue))) {
          href = "/news/filter/" + category.getAttribute("data-value") + "/" + yearValue + "/" + monthValue;
        } else if (Number.isInteger(parseInt(yearValue))) {
          href = "/news/filter/" + category.getAttribute("data-value") + "/" + yearValue;
        } else {
          href = "/news/filter/" + category.getAttribute("data-value");
        }

        window.location.href = href;
      });
    });

    Array.from(year.querySelectorAll("li button")).forEach(function (year) {
      year.addEventListener("click", function (e) {
        var href = "";

        if (e.target.textContent === "Year") {
          if (categoryNewsValue !== "Category") {
            href = "/news/filter/" + categoryNewsValue;
          } else {
            href = "/news";
          }
        } else {
          if (categoryNewsValue !== "Category" && Number.isInteger(parseInt(monthValue))) {
            href = "/news/filter/" + categoryNewsValue + "/" + year.getAttribute("data-value") + "/" + monthValue;
          } else if (categoryNewsValue !== "Category") {
            href = "/news/filter/" + categoryNewsValue + "/" + year.getAttribute("data-value") + "/01";
          } else if (Number.isInteger(parseInt(monthValue))) {
            href = "/news/filter/date/" + year.getAttribute("data-value") + "/" + monthValue;
          } else {
            href = "/news/filter/date/" + year.getAttribute("data-value");
          }
        }

        window.location.href = href;
      });
    });

    Array.from(month.querySelectorAll("li button")).forEach(function (month) {
      month.addEventListener("click", function (e) {
        var href = "";

        if (e.target.textContent === "Month") {
          if (categoryNewsValue !== "Category" && Number.isInteger(parseInt(yearValue))) {
            href = "/news/filter/" + categoryNewsValue + "/" + yearValue;
          } else if (categoryNewsValue !== "Category") {
            href = "/news/filter/date/" + new Date().getFullYear();
          } else if (Number.isInteger(parseInt(yearValue))) {
            href = "/news/filter/date/" + yearValue;
          } else {
            href = "/news/filter/date/" + new Date().getFullYear();
          }
        } else {
          if (categoryNewsValue !== "Category" && Number.isInteger(parseInt(yearValue))) {
            href = "/news/filter/" + categoryNewsValue + "/" + yearValue + "/" + month.getAttribute("data-value");
          } else if (categoryNewsValue !== "Category") {
            href = "/news/filter/date/" + new Date().getFullYear() + "/" + month.getAttribute("data-value");
          } else if (Number.isInteger(parseInt(yearValue))) {
            href = "/news/filter/date/" + yearValue + "/" + month.getAttribute("data-value");
          } else {
            href = "/news/filter/date/" + new Date().getFullYear() + "/" + month.getAttribute("data-value");
          }
        }

        window.location.href = href;
      });
    });
  }

  /**
   * Form
   */
  {
    var form = document.querySelector(".js-form");

    if (form) {
      var submitButton = form.querySelector('button[type="submit"]');
      var submitButtonLabel = submitButton.textContent;

      form.addEventListener("blur", function (e) {
        validate(form);
      }, true);
      form.addEventListener("input", function (e) {
        e.target.classList.add("has-input");
      }, true);
      form.addEventListener("submit", function (e) {
        e.preventDefault();

        Array.from(form.querySelectorAll("input,textarea")).forEach(function (field) {
          field.classList.add("has-input");
        });
        if (validate(form, true)) {
          submitButton.textContent = "Sending...";
          submitButton.disabled = true;
          var formData = new window.FormData(form);
          formData.append("_token", document.querySelector('meta[name="csrf-token"]').content);
          window.fetch(window.site.url + "/centre-information/contact", {
            method: "post",
            body: formData,
            credentials: "include"
          }).then(function (res) {
            return res.json();
          }).then(function (json) {
            submitButton.disabled = false;
            submitButton.textContent = submitButtonLabel;
            var successEl = document.createElement("div");
            successEl.classList.add("cf-success");
            successEl.innerHTML = "<p>Message has been sent successfully! We’ll aim to get back to you within 24 hours.</p>";
            form.parentNode.insertBefore(successEl, form);
            form.parentNode.removeChild(form);
          });
        }
      });
    }
  }

  /**
   * Table wrapper
   */
  {
    var tables = Array.from(document.querySelectorAll(".article table"));
    tables.forEach(function (table) {
      var wrapper = document.createElement("div");
      wrapper.classList.add("article-table-container");
      __WEBPACK_IMPORTED_MODULE_5__helper__["a" /* default */].wrap(table, wrapper);
    });
  }
}

function validate(form) {
  var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var selector = "input.has-input, textarea.has-input";
  if (all) selector = "input, textarea";
  var fields = Array.from(form.querySelectorAll(selector));
  clearErrors(form);

  var errorCount = 0;

  fields.forEach(function (field) {
    if (field.required && field.value.trim() === "") {
      if (field.classList.contains("js-select-field")) {
        var select = field.closest(".js-select");
        showError(select, select.getAttribute("aria-label") + " is required");
      } else {
        var label = form.querySelector("label[for=\"" + field.id + "\"]");
        showError(field, label.textContent + " is required");
      }
      errorCount++;
      return;
    }
    if (field.type === "email" && !isEmail(field.value)) {
      showError(field, "Please enter a valid email address");
      errorCount++;
    }
  });

  return errorCount === 0;
}

function clearErrors(form) {
  var errors = Array.from(form.querySelectorAll(".form-error"));
  errors.forEach(function (error) {
    error.parentNode.removeChild(error);
  });

  var inputs = Array.from(form.querySelectorAll(".has-error"));
  inputs.forEach(function (input) {
    input.classList.remove("has-error");
  });
}

function showError(input, message) {
  var error = document.createElement("p");
  error.classList.add("form-error");
  error.textContent = message;
  input.parentNode.insertBefore(error, input.nextSibling);
  input.classList.add("has-error");
}

function isEmail(email) {
  // eslint-disable-next-line
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

if (document.readyState !== "loading") {
  main();
} else {
  document.addEventListener("DOMContentLoaded", main);
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.bad8865e788d3deea4d1.js